import React from 'react'
import { Box, Divider, Text } from '@chakra-ui/react'

export interface HelpSupportProps {
  title: string
  tel?: string
  line?: boolean
}

const HelpSupport: React.FC<HelpSupportProps> = ({ title, tel, line = true }) => (
  <Box paddingTop='28'>
    {line && <Divider borderColor='grey.120' width='536px' mt={10} />}
    {title && (
      <Text color='grey.120' fontWeight='bold' data-testid='messageTitle' textAlign='center' marginTop='30px' maxW='503px'>
        {title}
      </Text>
    )}
    {tel && (
      <Text data-testid='cellPhone' textStyle='h3' textAlign='center' marginTop='5px' color='grey.120'>
        {tel}
      </Text>
    )}
  </Box>
)

export default HelpSupport
